import classNames from 'classnames';

import getAnswerLabel from '../../lib/getAnswerLabel';

import styles from '../../styles/partials/form-answers.module.css';

interface FormAnswersProps {
    fields: FormField[];
    answers: Record<string, unknown>;
    className?: string | null;
}

function FormAnswers({ fields, answers, className = null }: FormAnswersProps) {
    const items = fields
        .map((field) => ({ field, answer: getAnswerLabel(field, answers[field.name]) }))
        .filter(({ answer }) => answer !== null);
    return items.length > 0 ? (
        <ul className={classNames([styles.container, className])}>
            {items.map(({ field: { name, label = null }, answer }) => (
                <li key={`answer-${name}`} className={styles.item}>
                    {label !== null ? <span className={styles.label}>{label}</span> : null}
                    <span className={styles.answer}>{answer}</span>
                </li>
            ))}
        </ul>
    ) : null;
}

export default FormAnswers;
